export default __webpack_public_path__ + "static/media/annex1.96d2e744.png";